<template>
  <div>
    <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_paths" />

    <div class="w-full flex flex-wrap">
      <div class="w-full md:w-1/2 px-2">
        <Fieldset legend="會員資訊" :toggleable="true">
          <div class="detail_fieldset_element">
            <div class="label">姓名</div>
            <div>{{ user_new.name ?? "（空白）" }}</div>
          </div>
          <div class="detail_fieldset_element">
            <div class="label">手機號碼</div>
            <div>{{ user_new.mobile ?? "（空白）" }}</div>
          </div>
          <div class="detail_fieldset_element">
            <div class="label">信箱</div>
            <div>{{ user_new.email ?? "（空白）" }}</div>
          </div>
          <div class="detail_fieldset_element">
            <div class="label">聯絡地址</div>
            <div v-if="user_new.shipping_info">
              {{ user_new.shipping_info.district?.zip ?? "（無郵遞區號）" }}
              {{ user_new.shipping_info.district?.name ?? "（無行政區）" }}
              {{ user_new.shipping_info.city ?? "（無城市）" }}
              {{ user_new.shipping_info.address ?? "（無地址）" }}
            </div>
            <div v-else>（空白）</div>
          </div>
          <div class="detail_fieldset_element">
            <div class="label">個人推薦碼</div>
            <div>{{ user_new.referral_code ?? "（空白）" }}</div>
          </div>
          <div class="detail_fieldset_element">
            <div class="label">加入時間</div>
            <div>
              {{ dayjs(user_new.created_at).format("YYYY-MM-DD HH:mm:ss") }}
            </div>
          </div>
          <div class="detail_fieldset_element">
            <div class="label">匯款資訊</div>
            <div v-if="user_new.payment_method">
              {{ user_new.payment_method.code ?? "（無銀行代碼）" }}
              {{ user_new.payment_method.name ?? "（無銀行名稱）" }}
              {{ user_new.payment_method.account ?? "（無銀行帳號）" }}
            </div>
            <div v-else>（空白）</div>
          </div>
        </Fieldset>
        <Fieldset legend="消費總額/CV值" :toggleable="true">
          <div>
            消費總額：{{
              $page.props.orders_total_price | commaFormat | priceFormat
            }}
          </div>
          <div>
            CV值：{{ $page.props.user.attributes.total_cv?.from_begin ?? 0 }}
          </div>
          <div>
            CVT值：{{ $page.props.user.attributes.total_cvt?.from_begin ?? 0 }}
          </div>
        </Fieldset>
        <Fieldset legend="獎勵金" :toggleable="true">
          <template v-if="$page.props.mv_records.length > 0">{{
            $page.props.mv_records
          }}</template>
          <template v-else>無資料</template>
        </Fieldset>
      </div>

      <div class="w-full md:w-1/2 px-2">
        <Fieldset legend="訂單紀錄" :toggleable="true">
          <div :key="order.order_no" v-for="order in $page.props.orders">
            <Link :href="route('admin.orders.edit', order.id)">{{
              order.order_no
            }}</Link>
          </div>
        </Fieldset>

        <Fieldset legend="會員類型" :toggleable="true">
          {{ memberString($page.props.user.level) }}
        </Fieldset>
        <Fieldset legend="會員組織" :toggleable="true">
          <div v-if="$page.props.parent || $page.props.children?.length">
            <div v-if="$page.props.parent" class="info-item">
              <div>推薦人</div>
              <div class="info-subitem">
                <div class="column">
                  <label>姓名</label>
                  {{ $page.props.parent.name }}
                </div>

                <div class="column">
                  <label>加入時間</label>
                  {{ formatDate($page.props.parent.created_at) }}
                </div>

                <div class="column">
                  <label>會員等級</label>
                  {{ memberString($page.props.parent.level) }}
                </div>
              </div>
            </div>

            <div v-if="$page.props.children.length" class="info-item">
              <div>已推薦成員 ({{ $page.props.children.length }})</div>
              <div class="info-subitem">
                <div class="column">
                  <label>姓名</label>
                  <span
                    :key="child.id + '_name'"
                    v-for="child in $page.props.children"
                  >
                    {{ child.name }}
                  </span>
                </div>

                <div class="column">
                  <label>加入時間</label>
                  <span
                    :key="child.id + '_created'"
                    v-for="child in $page.props.children"
                  >
                    {{ formatDate(child.created_at) }}
                  </span>
                </div>

                <div class="column">
                  <label>會員等級</label>
                  <span
                    :key="child.id + '_level'"
                    v-for="child in $page.props.children"
                  >
                    {{ memberString(child.level) }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div v-else>沒有推薦人及已推薦成員</div>
        </Fieldset>

        <Fieldset legend="購物金" :toggleable="true">
          可用購物金：{{ $page.props.user.bonus | commaFormat }}
          <div class="info-subitem">
            <div class="column">
              <label>日期</label>
              <span
                :key="child.id + '_created_at'"
                v-for="child in $page.props.bonus_records"
              >
                {{ formatDate(child.created_at) }}
              </span>
            </div>

            <div class="column">
              <label>金額</label>
              <span
                :key="child.id + '_amount'"
                v-for="child in $page.props.bonus_records"
              >
                {{ child.amount | commaFormat }}
              </span>
            </div>

            <div class="column">
              <label>到期日</label>
              <span
                :key="child.id + '_expire_at'"
                v-for="child in $page.props.bonus_records"
              >
                {{ child.expire_at ?? "（無到期日）" }}
              </span>
            </div>
          </div>
        </Fieldset>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "../Layout";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import Fieldset from "primevue/fieldset";

export default {
  layout: Layout,
  components: {
    Breadcrumb,
    Fieldset,
  },
  props: {
    user: Object,
  },
  data() {
    return {
      breadcrumb_home: {
        label: "使用者管理",
        disabled: true,
      },
      breadcrumb_paths: [
        {
          label:
            this.$page.props.from &&
            decodeURIComponent(atob(this.$page.props.from)).includes(
              "users/level"
            )
              ? "客戶級別管理"
              : "客戶總覽",
          to: this.$page.props.from
            ? decodeURIComponent(atob(this.$page.props.from))
            : route("admin.users"),
        },
        {
          label: this.user.name,
          disabled: true,
        },
      ],
      user_new: Object.assign({}, this.$props.user),
    };
  },
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  methods: {
    formatDate(dateString) {
      let date = new Date(dateString);
      return (
        date.getFullYear() +
        "/" +
        (date.getMonth() + 1).toString().padStart(2, "0") +
        "/" +
        date.getDate().toString().padStart(2, "0")
      );
    },
    memberString(level) {
      switch (level) {
        case 0:
          return "新晉會員";
        case 1:
          return "一般會員";
        case 2:
          return "推廣會員";
        default:
          return "會員";
      }
    },
  },
};
</script>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}

Fieldset {
  @apply my-5;
}

.item {
  @apply my-2;
}

.detail_fieldset_element {
  @apply mb-2;
}

.label {
  @apply text-xs;
}

.info-item {
  @apply mb-5 p-2 border border-fh-gray-border;
}

.info-subitem {
  @apply mt-2 py-2 flex justify-start flex-wrap gap-8;
}

.info-subitem .column {
  @apply flex flex-col basis-1/4;
}

.info-subitem .column label {
  @apply text-xs;
}
</style>